import { render, staticRenderFns } from "./addHotel.vue?vue&type=template&id=6c87d70b&scoped=true"
import script from "./addHotel.vue?vue&type=script&lang=js"
export * from "./addHotel.vue?vue&type=script&lang=js"
import style0 from "./addHotel.vue?vue&type=style&index=0&id=6c87d70b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87d70b",
  null
  
)

export default component.exports